__turbopack_context__.v({
  "animation": "Focus-module-scss-module__3rbzEG__animation",
  "focus": "Focus-module-scss-module__3rbzEG__focus",
  "limitedSpace": "Focus-module-scss-module__3rbzEG__limitedSpace",
  "spin": "Focus-module-scss-module__3rbzEG__spin",
});
